import {createSlice} from "@reduxjs/toolkit";

export const formStateSlice = createSlice({
    name: 'formState',
    initialState: {
        clientAccountId: null,
        clientId: null,
        formType: null,
    },
    reducers: {
        setClientAccountId: (state, action) => {
            state.clientAccountId = action.payload;
        },
        setClientId: (state, action) => {
            state.clientId = action.payload;
        },
        setFormType: (state, action) => {
            state.formType = action.payload;
        }
    },
});

export const { setClientAccountId,setClientId, setFormType } = formStateSlice.actions;
export default formStateSlice.reducer;
